import { call, takeEvery } from 'redux-saga/effects'
import { api, Response } from '../../function/axios'
import { handleError } from '../../function/error'
import * as actionType from './actionType'

function* createQrRegistration(action: actionType.CreateQrRegistration) {
  try {
    // The backend endpoint is multipart/form-data (it also accepts the
    // optional background-image file), so every field goes through
    // FormData even when there's no file — axios sets the multipart
    // boundary header itself off the FormData instance (see
    // marketing/saga.ts's postTelegramCampaign for the same pattern).
    const formData = new FormData()
    if (action.data.label) formData.append('label', action.data.label)
    if (action.data.validFrom) formData.append('validFrom', action.data.validFrom)
    if (action.data.validUntil) formData.append('validUntil', action.data.validUntil)
    if (action.data.file) formData.append('file', action.data.file)

    const { data }: Response = yield call(api, {
      method: 'POST',
      url: '/auth/qr-registration',
      body: formData,
    })

    yield call(action.callback, data)
  } catch (e) {
    yield call(handleError, e)
    if (action.onError) yield call(action.onError)
  }
}

function* deactivateQrRegistration(action: actionType.DeactivateQrRegistration) {
  try {
    const { data }: Response = yield call(api, {
      method: 'PUT',
      url: `/auth/qr-registration/${action.id}/deactivate`,
    })

    yield call(action.callback, data)
  } catch (e) {
    yield call(handleError, e)
    if (action.onError) yield call(action.onError)
  }
}

export function* watchQrRegistration() {
  yield takeEvery(actionType.CREATE_QR_REGISTRATION, createQrRegistration)
  yield takeEvery(actionType.DEACTIVATE_QR_REGISTRATION, deactivateQrRegistration)
}
